// libs
import React, { memo } from 'react';
import { styled } from '@nykaa/ui-components';

// components
import { BRAND_PRIMARY_COLOR, DWEB_MAX_WIDTH, BREAKPOINTS } from 'shared/styles/base';

const Container = styled.section`
  width: 100%;
  max-width: ${DWEB_MAX_WIDTH}px;
  margin: ${({ theme }) => theme.spacing.spacing20} auto ${({ theme }) => theme.spacing.spacing40};
  padding: 0 10px;
  ${({ theme }) => theme.typography.bodyMedium};

  a {
    color: ${BRAND_PRIMARY_COLOR};
    margin-left: 3px;
  }

  h2 {
    ${({ theme }) => theme.typography.titleSmall}

    @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
      ${({ theme }) => theme.typography.titleXSmall}
    }
  }
`;

const Header = styled.h2`
  ${({ theme }) => theme.typography.subTitleMedium};
`;

const Link = styled.a`
  display: inline-block;
  color: ${({ theme }) => theme.colors.salmon500};
  margin: 0 3px;
`;

function GenericBrandDesc() {
  return (
    <Container>
      <Header>
        NYKAA FASHION – YOUR ONE-STOP ONLINE SHOPPING SITE FOR CLOTHES, ACCESSORIES FOOTWEAR &amp;
        MORE
      </Header>
      <p>
        Nykaa Fashion online shopping store is India’s one of the finest and the best online
        shopping destination for men, women and kids. Being a host to a wide array of lifestyle and
        fashion brands, Nykaa Fashion retails an extensive range of fashion apparels, accessories
        footwear and more for men, women and kids from over 500 plus international brands like
        <Link
          href="https://www.nykaafashion.com/designers/vero-moda/c/4188"
          target="_blank"
          rel="noopener noreferrer"
        >
          Vero Moda
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/designers/only/c/4189"
          target="_blank"
          rel="noopener noreferrer"
        >
          Only
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/designers/aeropostale/c/6712"
          target="_blank"
          rel="noopener noreferrer"
        >
          Aeropostale
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/designers/gap/c/6269"
          target="_blank"
          rel="noopener noreferrer"
        >
          Gap
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/designers/puma/c/4886"
          target="_blank"
          rel="noopener noreferrer"
        >
          Puma
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/designers/adidas/c/7200"
          target="_blank"
          rel="noopener noreferrer"
        >
          Adidas
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/designers/forever-new/c/4495"
          target="_blank"
          rel="noopener noreferrer"
        >
          Forever New
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/designers/american-eagle/c/7077"
          target="_blank"
          rel="noopener noreferrer"
        >
          American Eagle
        </Link>
        , etc. and Indian designers like
        <Link
          href="https://www.nykaafashion.com/designers/tarun-tahiliani/c/6674"
          target="_blank"
          rel="noopener noreferrer"
        >
          Tarun Tahiliani
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/designers/ritu-kumar/c/196"
          target="_blank"
          rel="noopener noreferrer"
        >
          Ritu Kumar
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/designers/varun-bahl/c/4100"
          target="_blank"
          rel="noopener noreferrer"
        >
          Varun Bahl
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/designers/masaba/c/138"
          target="_blank"
          rel="noopener noreferrer"
        >
          Masaba
        </Link>
        , etc. Our LUXE store brings to you the latest designer collections straight out of the
        fashion houses delivered right to your doorstep. Shop clothes online, footwear online,
        accessories online, lingerie online and everything online to save time and most importantly
        money with Nykaa Fashion’s exclusive offers and discounts during seasonal sales and more.
        Get exclusive access to the latest fashion trends, authentic designer collections, the
        newest and most stylish seasonal fashion and much more from the comfort of your home with
        the Nykaa Fashion online shopping app. Download the Nykaa Fashion Android app from the Play
        Store or the iOS App from the Apple App Store, where accessories, footwear and clothes
        shopping for you and your family will be an absolute delight. From fashion clothing for day
        to day use to occasion-ready clothes for special festivities and wedding occasions, Nykaa
        Fashion online clothing store has got it all for you.
      </p>
      Also, we at Nykaa Fashion have a section named
      <Link
        href="https://www.nykaafashion.com/style-files.html"
        target="_blank"
        rel="noopener noreferrer"
      >
        Style Files
      </Link>
      where you can discover the latest trends in women’s fashion and styling ideas to stay in
      vogue. Thus, if you are looking for women’s fashion wear, ladies fashion wear or fashion
      clothes for girls, you will be spoiled for choice as Nykaa Fashion has got it all!
      <Header>
        SHOP LATEST COLLECTIONS APPARELS, ACCESSORIES AND MORE FOR WOMEN ONLINE AT NYKAA FASHION
      </Header>
      <p>
        Shopping online for women’s clothing ,
        <Link
          href="https://www.nykaafashion.com/footwear/c/3528"
          target="_blank"
          rel="noopener noreferrer"
        >
          footwear
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/jewellery/c/77"
          target="_blank"
          rel="noopener noreferrer"
        >
          jewellery
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/women/bags/handbags/c/669"
          target="_blank"
          rel="noopener noreferrer"
        >
          handbags
        </Link>
        , etc. at Nykaa Fashion is sure to be an elevating experience for you. From trendy
        <Link
          href="https://www.nykaafashion.com/indianwear/c/4"
          target="_blank"
          rel="noopener noreferrer"
        >
          ethnic wear for women
        </Link>
        to fashion-forward contemporary and fusion wear collections for women, you can trust Nykaa
        Fashion online shopping store to always brings you the latest fashion trends, new styles,
        off-the-runway collections and more on the daily. Browse through the latest collections of
        footwear for women from renowned brands like
        <Link
          href="https://www.nykaafashion.com/designers/metro/c/4383"
          target="_blank"
          rel="noopener noreferrer"
        >
          Metro
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/designers/mochi/c/4382"
          target="_blank"
          rel="noopener noreferrer"
        >
          Mochi
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/designers/birkenstock/c/7729"
          target="_blank"
          rel="noopener noreferrer"
        >
          Birkenstock
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/designers/paio/c/4341"
          target="_blank"
          rel="noopener noreferrer"
        >
          Paio
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/designers/preet-kaur/c/3892"
          target="_blank"
          rel="noopener noreferrer"
        >
          Preet Kaur
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/designers/twenty-dresses/c/4240"
          target="_blank"
          rel="noopener noreferrer"
        >
          Twenty Dresses
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/designers/sole-head/c/5139"
          target="_blank"
          rel="noopener noreferrer"
        >
          Sole Head
        </Link>
        and many more by downloading the Nykaa Fashion online shopping app. Discover wide
        collections of
        <Link
          href="https://www.nykaafashion.com/women/bags/c/89"
          target="_blank"
          rel="noopener noreferrer"
        >
          women’s bags
        </Link>
        like tote bags, satchel bags, sling bags, cross-body bags, shopper bags and more at our
        online website. From summer dresses, jumpsuits, skirts, shorts and more to winter sweaters,
        sweatshirts, coats, jackets and more, find the latest and the best of western wear
        collections online at Nykaa Fashion. Get your hands on the latest Indian wear collections
        and ready to wear dresses, gowns, salwar suits, kurtas and kurtis, sarees, lehengas and more
        when online shopping for women at Nykaa Fashion.
      </p>
      <Header>DISCOVER FASHION-FORWARD MENSWEAR COLLECTION ONLINE AT NYKAA FASHION</Header>
      <p>
        At Nykaa Fashion online shopping store, you will find a myriad of options for men online
        ranging from casual shirts, trousers, etc. to formal suits, blazers, shoes and more. When it
        comes to men’s fashion collection at Nykaa Fashion, you are sure to find plenty of options
        in apparels, accessories, footwear and more that are not only trend-led but as well make for
        a timeless addition to your esteemed collection. On your online men’s clothing shopping
        journey at Nykaa Fashion, discover fashion-forward collections from brands like
        <Link
          href="https://www.nykaafashion.com/designers/peter-england/c/6958"
          target="_blank"
          rel="noopener noreferrer"
        >
          Peter England
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/designers/arrow/c/7098"
          target="_blank"
          rel="noopener noreferrer"
        >
          Arrow
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/designers/gap/c/6269"
          target="_blank"
          rel="noopener noreferrer"
        >
          GAP
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/designers/american-eagle/c/7077"
          target="_blank"
          rel="noopener noreferrer"
        >
          American Eagle
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/designers/louis-philippe/c/6967"
          target="_blank"
          rel="noopener noreferrer"
        >
          Louis Philippe
        </Link>
        and many more suited for all your casual, semi-casual and formal needs. Explore the latest
        range on
        <Link
          href="https://www.nykaafashion.com/men/footwear/c/6857"
          target="_blank"
          rel="noopener noreferrer"
        >
          men’s footwear
        </Link>
        collections ranging from formal pairs like dress shoes, brogues, oxfords, loafers and more
        to athletic sneakers, sporty shoes, casual kicks and more from the comfort of your home and
        office with the Nykaa Fashion online shopping app. Whether you are online shopping for men
        for
        <Link
          href="https://www.nykaafashion.com/men/bags-and-backpacks/c/6867"
          target="_blank"
          rel="noopener noreferrer"
        >
          men’s bags
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/men/personal-accessories/belts/c/6882"
          target="_blank"
          rel="noopener noreferrer"
        >
          belts
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/men/personal-accessories/wallets/c/6881"
          target="_blank"
          rel="noopener noreferrer"
        >
          wallets
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/men/personal-accessories/sunglasses/c/6880"
          target="_blank"
          rel="noopener noreferrer"
        >
          sunglasses
        </Link>
        , etc. or men’s athletic apparels and accessories, Nykaa Fashion online shopping store is
        sure to be your one-stop destination for all.
      </p>
      <Header>
        BUY IRRESISTIBLY COOL AND COMFORTABLE KIDSWEAR COLLECTIONS ONLINE AT NYKAA FASHION
      </Header>
      <p>
        When it comes to online shopping for kids, Nykaa Fashion brings you an extensive range of
        kid’s clothing collections like
        <Link
          href="https://www.nykaafashion.com/kids/westernwear/dresses/c/6284"
          target="_blank"
          rel="noopener noreferrer"
        >
          dresses
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/kids/c/6266"
          target="_blank"
          rel="noopener noreferrer"
        >
          accessories
        </Link>
        , footwear ,
        <Link
          href="https://www.nykaafashion.com/kids/westernwear/tops/c/6286"
          target="_blank"
          rel="noopener noreferrer"
        >
          tops
        </Link>
        and more for all occasions and locations. From well known international brands like
        <Link
          href="https://www.nykaafashion.com/designers/hamleys/c/7371"
          target="_blank"
          rel="noopener noreferrer"
        >
          Hamley’s
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/designers/gap/c/6269"
          target="_blank"
          rel="noopener noreferrer"
        >
          GAP
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/designers/gini-jony/c/6551"
          target="_blank"
          rel="noopener noreferrer"
        >
          Gini &amp; Jony
        </Link>
        , Puma, Crocs and more to top-notch local labels like
        <Link
          href="https://www.nykaafashion.com/designers/kidsville/c/6499"
          target="_blank"
          rel="noopener noreferrer"
        >
          Kidsville
        </Link>
        ,
        <Link
          href="https://www.nykaafashion.com/designers/nino-bambino/c/6540"
          target="_blank"
          rel="noopener noreferrer"
        >
          Nino Bambino
        </Link>
        , Biba and more, you can browse through endless collections of clothing apparels,
        accessories, footwear and more for your little boys and girls, toddlers as well as for
        infants with the Nykaa Fashion online shopping app. Discover elegant collections of kid’s
        footwear like boots, sandals, flip flops, as well as school shoes, sneakers and more at our
        online store. Get your little one&apos;s school-ready with our edit of notebooks and
        stationery, lunch boxes, water bottles, school bags and backpacks and more. Explore from a
        wide range of feeding accessories, comfortable sleep sets ,
        <Link
          href="https://www.nykaafashion.com/kids/toys-and-games/c/6382"
          target="_blank"
          rel="noopener noreferrer"
        >
          toys
        </Link>
        , home accessories and more in adorable styles and designs, only at your one-stop-shop,
        Nykaa Fashion.
      </p>
    </Container>
  );
}

export default memo(GenericBrandDesc);
